<!-- ─── Desktop Header ──────────────────────────────────────────────────────── -->
<header class="header d-none d-lg-block" [ngClass]="{ scrolled: isScrolled }" role="banner">
  <app-cta-banner></app-cta-banner>
  <div class="d-flex">
    <div class="header__bar">

      <!-- Logo — text gradient per Figma design -->
      <a class="header__logo" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" #navigation (click)="addActive($event, '')" aria-label="SEERDEX — go to homepage">
        <img src="/assets/images/svg-icons/logo.svg" alt="SEERDEX logo" loading="lazy" class="header__logo-img img-fluid mwx-180">
        <!-- <span class="header__logo-text">SEERDEX</span> -->
      </a>

      <!-- Navigation links -->
      <nav class="header__nav" aria-label="Main navigation">
        <!-- <a class="header__nav-link" (click)="addActive($event, 'staking')" routerLink="/{{ currentLanguage !== 'en' ? `${currentLanguage}/staking` : 'staking' }}" title="staking">
          {{ "top_navigation.nav_staking" | translate }}
        </a> -->
        @for (item of navigations; track item.routeName) {
        <a class="header__nav-link" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" fragment="{{ item.routeName }}" (click)="addActive($event, item.routeName)" title="{{ item.routeName }}">
          {{ item.navName | translate }}
        </a>
        }
        <!-- 
        <div class="btn-group docs ms-2" dropdown>
          <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center header__nav-link">
            {{ "top_navigation.nav_docs" | translate }}
            <svg-icon class="dropdown ms-2" src="./assets/images/svg-icons/angle-down.svg"
              [svgStyle]="{ 'width.px': '14', 'height.px': '22' }"></svg-icon>
          </div>

          <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
            <li class="cursor-pointer" role="menuitem">
              <a href="https://seerdex.gitbook.io/seerdex-whitepaper" target="_blank" rel="noopener noreferrer"
                class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                <span class="fw-normal letter-spacing-0">{{ 'misc.whitepaper' | translate }}</span>
              </a>
            </li>
            <li class="cursor-pointer" role="menuitem">
              <a href="./assets/documents/seerdex-audit.pdf" target="_blank" rel="noopener noreferrer"
                class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                <span class="fw-normal letter-spacing-0">{{ 'misc.audit' | translate }}</span>
              </a>
            </li>
          </ul>
        </div> -->
      </nav>

      <div class="d-flex align-items-center">

        <!-- Social links -->
        <div class="social-wrap d-flex align-items-center justify-content-center">
          @for (item of social; track item.alt) {
          <a href="{{ item.link }}" target="_blank" rel="noopener noreferrer" (click)="vwoData(item)">
            <img [src]="item.img" [alt]="item.alt" loading="lazy" />
          </a>
          }
        </div>

        <!-- ----- language dropdown ------ -->
        <!-- <div class="btn-group language ms-2" dropdown>
          <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center">
            <img class="flag-icon" src="./assets/images/flags/{{selectedLanguage.flag}}.svg" [alt]="selectedLanguage.value" loading="lazy">
            <div class="font-12 text-uppercase fw-semibold mx-2 text-grey">{{ selectedLanguage.value }}</div>
            <svg-icon class="dropdown ms-1" src="./assets/images/svg-icons/angle-down.svg" [svgStyle]="{ 'width.px': '14', 'height.px': '22' }"></svg-icon>
          </div>

          <ul *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu">
            @for (lang of languagesList; track lang) {
            <li class="cursor-pointer" role="menuitem" [ngClass]="{'active': selectedLanguage.value === lang.value}">
              @if (!isStaking) {
              <a routerLink="/{{lang.value === 'en' ? '' : lang.value}}" [fragment]="hashKey || undefined" class="m-0 p-2 lang-link d-flex justify-content-start align-items-center w-100">
                <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name + 'flag'" loading="lazy" />
                <span class="fw-normal letter-spacing-0">{{ lang.native_name }}</span>
              </a>
              }
              @if (isStaking) {
              <a routerLink="/{{lang.value === 'en' ? '' : lang.value}}/staking" class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                <img src="./assets/images/flags/{{ lang.flag }}.svg" [alt]="lang.native_name + 'flag'" loading="lazy" />
                <span class="font-16 fw-normal letter-spacing-0">{{ lang.native_name }}</span>
              </a>
              }
            </li>
            }
          </ul>
        </div> -->

        <!-- CTA — wallet connect / address display -->
        @if (!walletAddress && isPresalestarted) {
        <button class="header__cta ms-2" (click)="connectModal()">
          {{ 'top_navigation.trade_now' | translate }}
        </button>
        }
        @if (walletAddress && isPresalestarted) {
        <button class="header__cta header__cta--connected m-2" (click)="disconnect()">
          {{ walletAddress | trimAddress }}
        </button>
        }

      </div>
    </div>
  </div>


</header>

<!-- ─── Mobile Header ───────────────────────────────────────────────────────── -->
<header class="header header--mobile d-flex d-lg-none" [ngClass]="{ scrolled: isScrolled }" role="banner">
  <app-cta-banner></app-cta-banner>

  <div class="header__mobile-bar">

    <a class="header__logo" routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" (click)="openCloseMenu()" aria-label="SEERDEX — go to homepage">
      <img src="/assets/images/svg-icons/logo.svg" alt="SEERDEX logo" loading="lazy" class="header__logo-img img-fluid mwx-150">
      <!-- <span class="header__logo-text">SEERDEX</span> -->
    </a>

    <button class="header__burger" (click)="openCloseMenu()" [attr.aria-expanded]="showMenu" aria-label="Toggle menu">
      <svg-icon src="./assets/images/svg-icons/{{ showMenu ? 'close-white' : 'burger-icon' }}.svg" [svgStyle]="{ 'width.px': 24, 'height.px': 24 }">
      </svg-icon>
    </button>

  </div>
  <!-- Mobile slide-out menu -->
  @if (showMenu) {
  <div class="menu-overlay">
    <div class="sub-menu" [ngClass]="{ open: openMenu }">

      <!-- Nav links -->
      <nav class="sub-menu__nav" aria-label="Mobile navigation">
        <!-- <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}/staking" title="staking" (click)="openCloseMenu()" routerLinkActive="active">
          {{ 'top_navigation.nav_staking' | translate }}
        </a> -->
        @for (item of navigations; track item.routeName) {
        <a routerLink="/{{ currentLanguage !== 'en' ? currentLanguage : '' }}" fragment="{{ item.routeName }}" (click)="addActive($event, item.routeName); openCloseMenu()" title="{{ item.routeName }}">
          {{ item.navName | translate }}
        </a>
        }
        <!-- <div class="btn-group docs w-100" dropdown>
          <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center justify-content-between w-100 header__nav-link">
            {{ 'top_navigation.nav_docs' | translate }}
            <svg-icon class="dropdown" src="./assets/images/svg-icons/down-arrow.svg" [svgStyle]="{ 'width.px': '14', 'height.px': '22' }">
            </svg-icon>
          </div>

          <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
            <li class="p-0 cursor-pointer" role="menuitem">
              <a href="https://seerdex.gitbook.io/seerdex-whitepaper" target="_blank" rel="noopener noreferrer" (click)="openCloseMenu()" class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                <span class="font-16 fw-normal letter-spacing-0">{{ 'misc.whitepaper' | translate }}</span>
              </a>
            </li>
            <li class="p-0 cursor-pointer" role="menuitem">
              <a href="./assets/documents/seerdex-audit.pdf" target="_blank" rel="noopener noreferrer" (click)="openCloseMenu()" class="m-0 p-2 lang-link d-flex justify-content-start w-100">
                <span class="font-16 fw-normal letter-spacing-0">{{ 'misc.audit' | translate }}</span>
              </a>
            </li>
          </ul>
        </div> -->
      </nav>

      <!-- Social links -->
      <span class="social-wrap d-flex align-items-center justify-content-center mb-3">
        @for (item of social; track item.alt) {
        <a href="{{ item.link }}" target="_blank" rel="noopener noreferrer" (click)="vwoData(item)">
          <img [src]="item.img" [alt]="item.alt" loading="lazy" />
        </a>
        }
      </span>

      <!-- Language dropdown -->
      <!-- <div class="btn-group language my-3" dropdown>
        <div dropdownToggle type="button" class="dropdown-toggle d-flex align-items-center justify-content-between">
          <div>
            <img class="flag-icon" [src]="'./assets/images/flags/' + selectedLanguage.flag + '.svg'" [alt]="selectedLanguage.value" loading="lazy" />
            <span class="ms-2 font-16 text-uppercase fw-semibold">{{ selectedLanguage.value }}</span>
          </div>
          <svg-icon class="dropdown" src="./assets/images/svg-icons/down-arrow.svg" [svgStyle]="{ 'width.px': '20', 'height.px': '20' }">
          </svg-icon>
        </div>

        <ul *dropdownMenu class="dropdown-menu dropdown-menu-left" role="menu">
          @for (lang of languagesList; track lang.value) {
          <li class="p-0 cursor-pointer" role="menuitem" [ngClass]="{ active: selectedLanguage.value === lang.value }">
            @if (!isStaking) {
            <a routerLink="/{{ lang.value === 'en' ? '' : lang.value }}" (click)="openCloseMenu()" class="m-0 p-2 lang-link d-flex justify-content-start w-100">
              <img [src]="'./assets/images/flags/' + lang.flag + '.svg'" [alt]="lang.native_name + ' flag'" loading="lazy" />
              <span class="font-16 fw-normal letter-spacing-0 text-capitalize">{{ lang.native_name }}</span>
            </a>
            }
            @if (isStaking) {
            <a routerLink="/{{ lang.value === 'en' ? '' : lang.value }}/staking" (click)="openCloseMenu()" class="m-0 p-2 lang-link d-flex justify-content-start w-100">
              <img [src]="'./assets/images/flags/' + lang.flag + '.svg'" [alt]="lang.native_name + ' flag'" loading="lazy" />
              <span class="font-16 fw-normal letter-spacing-0 text-capitalize">{{ lang.native_name }}</span>
            </a>
            }
          </li>
          }
        </ul>
      </div> -->

      <!-- Mobile CTA -->
      @if (!walletAddress) {
      <button class="header__cta w-100 mt-2" (click)="showWidget('home'); openCloseMenu()">
        {{ 'top_navigation.trade_now' | translate }}
      </button>
      }
      @if (walletAddress) {
      <button class="header__cta header__cta--connected w-100 mt-2" (click)="disconnect(); openCloseMenu()">
        {{ walletAddress | trimAddress }}
      </button>
      }

    </div>
  </div>
  }


</header>